import React, {Component} from 'react';
import {
  StyleSheet,
  Text,
  View,
  Image,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import PropTypes from 'prop-types';
import menu_Icon from '../assets/menuIcon.png'; //'../../assets/menuIcon.png';
import CommonStyleSheet from '../StyleSheets/CommonStyleSheet';
import ListingsHeaderV2 from '../MainListing/ListingsHeaderV2';
import {ThemeContext} from '../HelperClasses/ThemeContext';
import {withLocale} from '../Localization/LocaleContext';

const windowWidth = Dimensions.get('window').width;

class NavigationHeader extends Component {
  static contextType = ThemeContext;
  t = (key, fallback) => this.props.localeContext?.translate?.(key, fallback) || fallback || key;
  static propTypes = {
    title: PropTypes.string,
    menuBtn: PropTypes.func,
    // backBtn: PropTypes.func,
    // showBackBtn: PropTypes.bool,
  };

  menuBtnView = props => {
    if (windowWidth < 700) {
      if (this.props.showBackBtn == true) {
        return (
          <TouchableOpacity
            style={styles.backBtnStyle}
            onPress={this.props.backBtn}>
            <Text>{this.t('common.back', 'Back')}</Text>
          </TouchableOpacity>
        );
      } else {
        return (
          <TouchableOpacity
            style={styles.backBtnStyle}
            onPress={this.props.menuBtn}>
            <Text>{this.t('navigation.sidebar_label', 'Side bar')}</Text>
          </TouchableOpacity>
        );
      }
    } else {
      if (this.props.showBackBtn == true) {
        return (
          <TouchableOpacity
            style={styles.backBtnStyle}
            onPress={this.props.backBtn}>
            <Text>{this.t('common.back', 'Back')}</Text>
          </TouchableOpacity>
        );
      } else {
        return <View></View>;
      }
    }
  };

  render() {
    return (
      <ListingsHeaderV2
        simple={true}
        titleArea={
          <Text
            style={[
              CommonStyleSheet.naviheaderTitleStyle,
              {color: this.context?.colors?.primaryText},
            ]}>
            {this.props.title}
          </Text>
        }
      />
    );
  }
}
export default withLocale(NavigationHeader);

const styles = StyleSheet.create({
  headerView: {
    height: 75,
    width: '100%',
    backgroundColor: 'white',
    // shadowColor: colors.Appgray,
    // shadowOpacity: 0.5,
    // shadowOffset: {width: 0, height: 0},
    // shadowRadius: 10,
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    // padding: 20,
  },
  imageStyle: {
    width: 30,
    height: 30,
    backgroundColor: 'brown',
    alignSelf: 'center',
    marginRight: 20,
    borderRadius: 15,
  },
  backBtnStyle: {
    marginLeft: 20,
  },
});
